import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const variants = {
  primary: "bg-brand-600 text-white hover:bg-brand-700 shadow-lg shadow-brand-600/20",
  white: "bg-white text-brand-800 hover:bg-brand-50 shadow-lg shadow-black/10",
  outline: "bg-transparent text-brand-700 border border-brand-200 hover:border-brand-400 hover:bg-brand-50",
};

export const CTAButton = ({ children, testid, variant = "primary", className = "" }) => (
  <Link
    to="/contact"
    data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-colors duration-300 active:scale-95 ${variants[variant]} ${className}`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);
